/* v4-coral-knot motion parity — Hydrogen HomePage.tsx @ 94cc6d6.
   Homepage + PDP only; no blog or cart logic. */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /** Scroll-reveal: .v4-reveal gets .--in when entering viewport. */
  function initReveal() {
    var nodes = document.querySelectorAll('.v4-reveal');
    if (!nodes.length) return;

    if (prefersReducedMotion()) {
      nodes.forEach(function (el) {
        el.classList.add('--in');
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        el.classList.add('--in');
      });
      return;
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('--in');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
    );

    nodes.forEach(function (el) {
      obs.observe(el);
    });
  }

  /** Hero capsule parallax via --p custom property (Hydrogen HomePage.tsx). */
  function initHeroParallax() {
    if (prefersReducedMotion()) return;
    var hero = document.querySelector('.v4-hero');
    if (!hero) return;

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var rect = hero.getBoundingClientRect();
        var progress = Math.max(-1, Math.min(1, -rect.top / Math.max(rect.height, 1)));
        hero.style.setProperty('--p', String(progress));
        ticking = false;
      });
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /** Benefit marquee: clone content for seamless loop when markup has a single set. */
  function initBenefitMarquee() {
    document.querySelectorAll('[data-marquee="benefits"]').forEach(function (marquee) {
      if (marquee.dataset.marqueeReady === '1') return;
      var track = marquee.querySelector('.benefit_marquee_track');
      var content = track && track.querySelector('.benefit_marquee_content');
      if (!track || !content) return;
      /* Liquid bal-pdp-marquee already ships two content sets — skip duplicate. */
      if (track.querySelectorAll('.benefit_marquee_content').length > 1) {
        marquee.dataset.marqueeReady = '1';
        return;
      }
      var clone = content.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      marquee.dataset.marqueeReady = '1';
    });
  }

  function boot() {
    initReveal();
    initHeroParallax();
    initBenefitMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
